var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendclockreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11h-1V9.693a1 1 0 00-.328-.74L7.905 7.347a.5.5 0 01.002-.742l1.761-1.582A1 1 0 0010 4.28V3h1V1L1 .976V3h1v1.28a1 1 0 00.332.744l1.761 1.582a.5.5 0 01.002.742L2.328 8.952a1 1 0 00-.328.74V11H1v1.976L11 13v-2zm-7-.585c0-.368.393-.713.653-.973L5.735 8.5a.375.375 0 01.53 0l1.083.942c.26.26.652.605.652.973V11H4v-.585z",
    fill: "#3B72A7"
  })));
}
export default SvgSendclockreact;